import React, { useEffect, useState } from 'react';
import {withRouter} from 'react-router';
import LatestNews from "../../common/LatestNews/LatestNews";
import NewsDetail from "../../common/NewsDetail/NewsDetail";
import Comment from "./Comment";
import Memorabilia from './Memorabilia';
import {getModule} from "./service";
import CateMenu from "../../common/CateMenu/CateMenu";
import PartnerNews from "./PartnerNews";

const About = (props) => {
    const { history, match } = props;
    const [moduleCate, setModuleCate] = useState([]);

    useEffect(() => {
        (async () => {
            let moduleCate = await getModule();
            if(moduleCate!=null){
                // 按照sort字段进行排序
                moduleCate.data.list.sort((item1,item2)=>{
                    return item1.sort-item2.sort;
                });
                // 过滤掉那些不展示的数据
                moduleCate.data.list=moduleCate.data.list.filter((item,index)=>{
                    return item.status === 1;
                });
            
                // console.log(moduleCate.data.list)

                let idx=moduleCate.data.list[moduleCate.data.list.length-1].id;
                moduleCate.data.list.push({id: idx+1, title: '经纬大事记'});
                // moduleCate.data.list.push({id: idx+2, title: '合作伙伴'});
                moduleCate.data.list.push({id: idx+3, title: '留言反馈'});

                setModuleCate(moduleCate.data.list);
                if (!match.params.cateId || !match.params.title) {
                    const { id, title } = moduleCate.data.list[0];
                    history.push({pathname: `/about/${id}/${title}`})
                }
            }
        })();
    }, []);

    const renderItem = () => {
        switch (match.params.cateId) {
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
                return <NewsDetail url="/api/Modular" hideHeader/>;
            case '6':
                return <Memorabilia/>;
            case '7':
                return <PartnerNews url="/admin/PartnerNews"/>;
            case '8':
                return <Comment/>;
            default:
                return <NewsDetail url="/api/Modular" hideHeader/>;
        }
    };

    return (
        <div style={{width: 1200, display: 'flex',minHeight:1072, justifyContent:'space-between'}}>
            <div style={{marginRight: 16}}>
                <CateMenu
                    title="走进经纬通达"
                    data={moduleCate}
                    onClick={({item, keyPath}) => {
                        window.scrollTo(0,300);
                        history.push({pathname: `/about/${keyPath[0]}/${item.props.children}`})
                    }}
                />
                <div style={{height: 16}}/>
                <LatestNews/>
            </div>
            {
                renderItem()
            }
        </div>
    )
}


export default withRouter(About);
